/* Inline-SVG icon set. TypeScript/JSX port of the prototype's icons.js.
   <Icon name="leaf" size={24} /> -> an inline <svg>. */
import * as React from 'react';

// Raw inner SVG path markup, keyed by icon name (viewBox 0 0 24 24).
export const PATHS = {
  calendar: '<rect x="3" y="4.5" width="18" height="16" rx="2.5"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/>',
  wallet: '<rect x="3" y="6" width="18" height="13" rx="2.5"/><path d="M3 9h13a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3"/><circle cx="16.5" cy="12.5" r="1.2" fill="currentColor" stroke="none"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  book: '<path d="M5 4.5h11a2 2 0 0 1 2 2V20a1.5 1.5 0 0 0-1.5-1.5H5z"/><path d="M5 4.5v15.5"/>',
  spark: '<path d="M12 3v5M12 16v5M4.5 12h5M14.5 12h5M6.5 6.5l3 3M14.5 14.5l3 3M17.5 6.5l-3 3M9.5 14.5l-3 3"/>',
  smile: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 14.5c1 1.3 2.2 2 3.5 2s2.5-.7 3.5-2"/><circle cx="9" cy="10" r="1" fill="currentColor" stroke="none"/><circle cx="15" cy="10" r="1" fill="currentColor" stroke="none"/>',
  team: '<circle cx="9" cy="9" r="3"/><path d="M3.5 19a5.5 5.5 0 0 1 11 0"/><path d="M16 6.2a3 3 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-3-4.9"/>',
  compass: '<circle cx="12" cy="12" r="8.5"/><path d="M15.5 8.5l-2 5-5 2 2-5z" fill="currentColor" stroke="none"/>',
  palette: '<path d="M12 3.5a8.5 8.5 0 0 0 0 17c1.4 0 2-1 2-1.8 0-1.5-1.3-1.6-1.3-2.7 0-.8.7-1.5 1.6-1.5H16a4.5 4.5 0 0 0 4.5-4.7C20.3 6.4 16.6 3.5 12 3.5z"/><circle cx="8" cy="11" r="1.1" fill="currentColor" stroke="none"/><circle cx="12" cy="8" r="1.1" fill="currentColor" stroke="none"/><circle cx="16" cy="10" r="1.1" fill="currentColor" stroke="none"/>',
  flag: '<path d="M6 21V4M6 4.5h11l-2 3.5 2 3.5H6"/>',
  chat: '<path d="M4.5 5.5h15a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H9l-4 3.5v-3.5a1.5 1.5 0 0 1-1.5-1.5V7a1.5 1.5 0 0 1 1.5-1.5z"/>',
  wrench: '<path d="M15 6.5a4 4 0 0 0-5 5L4.5 17a2 2 0 1 0 2.8 2.8L13 14a4 4 0 0 0 5-5l-2.5 2.5L13 10l1-3.5z"/>',
  calc: '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 11h2M12 11h2M16 11h0.01M8 15h2M12 15h2M16 15v3"/>',
  flask: '<path d="M9 3h6M10 3v6l-4.5 8a2 2 0 0 0 1.8 3h9.4a2 2 0 0 0 1.8-3L14 9V3"/><path d="M7.5 15h9"/>',
  clipboard: '<rect x="5" y="4.5" width="14" height="16" rx="2"/><rect x="9" y="2.5" width="6" height="4" rx="1.2"/><path d="M8.5 11h7M8.5 15h5"/>',
  chip: '<rect x="6.5" y="6.5" width="11" height="11" rx="2"/><path d="M9.5 10.5h5v3h-5z" fill="currentColor" stroke="none"/><path d="M9 2.5v3M15 2.5v3M9 18.5v3M15 18.5v3M2.5 9h3M2.5 15h3M18.5 9h3M18.5 15h3"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
  arrowR: '<path d="M5 12h13M13 6l6 6-6 6"/>',
  arrowL: '<path d="M19 12H6M11 6l-6 6 6 6"/>',
  star: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 17l-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z"/>',
  user: '<circle cx="12" cy="8" r="3.8"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>',
  ring: '<circle cx="12" cy="12" r="8.5"/>',
  heart: '<path d="M12 20s-7-4.4-7-9.3A4.2 4.2 0 0 1 12 7.5 4.2 4.2 0 0 1 19 10.7C19 15.6 12 20 12 20z"/>',
  paw: '<ellipse cx="7" cy="11" rx="1.6" ry="2.2"/><ellipse cx="17" cy="11" rx="1.6" ry="2.2"/><ellipse cx="10" cy="7.5" rx="1.5" ry="2"/><ellipse cx="14" cy="7.5" rx="1.5" ry="2"/><path d="M12 13c-2.4 0-4.3 1.7-4.3 3.6S9 19 12 19s4.3-.5 4.3-2.4S14.4 13 12 13z"/>',
  sun: '<circle cx="12" cy="12" r="4.5"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8"/>',
  confetti: '<path d="M4 20l5-13 8 8z"/><path d="M9 7l1-3M14 4l.5 2.5M19 8l2.5-.5M17 13l2.5 1" stroke-width="1.6"/>',
  rocket: '<path d="M12 3c3 1.5 5 4.5 5 8.5 0 2-.7 3.7-1.5 5h-7c-.8-1.3-1.5-3-1.5-5C7 7.5 9 4.5 12 3z"/><circle cx="12" cy="9.5" r="1.6"/><path d="M9 17l-2 4M15 17l2 4M12 17v4"/>',
  trophy: '<path d="M7 4.5h10v3a5 5 0 0 1-10 0z"/><path d="M7 5.5H4.5v1A3 3 0 0 0 7.5 9.5M17 5.5h2.5v1a3 3 0 0 1-3 3M12 12.5V16M8.5 20h7M9.5 20l.7-4h3.6l.7 4"/>',
  cap: '<path d="M12 4l9 4-9 4-9-4z"/><path d="M6 10v4.5c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5V10M21 8v5"/>',
  leaf: '<path d="M5 19C5 10 11 5 19 5c0 8-5 14-14 14z"/><path d="M12 12c-3 2-5 4.5-7 7"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  minus: '<path d="M5 12h14"/>',
  home: '<path d="M4 11l8-6 8 6M6 10v9h12v-9"/>',
  lock: '<rect x="5" y="10.5" width="14" height="9.5" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/>',
  dollar: '<path d="M12 3v18M16 7.5c0-1.7-1.8-3-4-3s-4 1.3-4 3 1.8 3 4 3 4 1.3 4 3-1.8 3-4 3-4-1.3-4-3"/>',
  download: '<path d="M12 3.5v11M7.5 10l4.5 4.5L16.5 10M4.5 19.5h15"/>',
  trash: '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
} as const;

export type IconName = keyof typeof PATHS;

interface IconProps {
  name: IconName;
  size?: number;
  sw?: number;
}

export function Icon({ name, size = 24, sw = 1.8 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: PATHS[name] || PATHS.star }}
    />
  );
}
